import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  Divider,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  searchData,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import {
  getInBranchItems,
  setMonthlyInventory,
  setalltoFalse,
} from "../../../Redux/actions/monthlyInventoryActions";

import { getProduct } from "../../../Redux/actions/productActions";
import { setProductInventory } from "../../../Redux/actions/inventoryActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { branchitems, user } = useSelector(
    (state) => ({
      branchitems: state.monthlyInventory.branchitems,
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [categorized_premix, setCategorized_premix] = useState([]);

  const [itemcount, setItemcount] = useState({});
  const [itemcount2, setItemcount2] = useState({});
  const STORAGE_KEY = "inventoryAuditData";

  const [currentWeighted, setCurrentWeighted] = useState(0);

  const [createDate, setCreatedDate] = useState(moment());

  useEffect(() => {
    getcurrentrate();
  }, []);
  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };

  useEffect(() => {
    if (!isModalVisible) return;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      try {
        const { date, itemcount: saved1, itemcount2: saved2 } = JSON.parse(raw);
        const today = moment().format("YYYY-MM-DD");
        if (date === today) {
          setItemcount(saved1);
          setItemcount2(saved2);
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    dispatch(getInBranchItems());
  }, [isModalVisible]);

  useEffect(() => {
    if (branchitems) {
      docategorized();
    }
  }, [branchitems]);

  // useEffect(() => {
  //   console.log(itemcount);
  //   console.log(itemcount2);
  // }, [itemcount, itemcount2]);

  const docategorized = () => {
    var categories = [];
    console.log("branchitems", branchitems.inventory);

    branchitems.inventory.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      branchitems.inventory.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    setCategorized(newcats);

    var categories_premix = [];

    console.log("branchitems premix", branchitems.premix);

    branchitems.premix.map((it) => {
      if (!categories_premix.includes(it.category_name)) {
        categories_premix.push(it.category_name);
      }
    });
    var newcats_premix = [];
    categories_premix.map((ct) => {
      var catprods = [];
      branchitems.premix.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats_premix.push(newcatp);
    });

    setCategorized_premix(newcats_premix);
  };

  const changequantity = (prod, count) => {
    const value = parseFloat(count) || 0;

    // build a brand-new object
    const next1 = { ...itemcount, [prod]: value };

    // immediately persist the updated map
    const today = moment().format("YYYY-MM-DD");
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ date: today, itemcount: next1, itemcount2 })
    );

    // and finally update React state
    setItemcount(next1);
  };

  const changequantity2 = (prod, count) => {
    const value = parseFloat(count) || 0;
    const next2 = { ...itemcount2, [prod]: value };

    const today = moment().format("YYYY-MM-DD");
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ date: today, itemcount, itemcount2: next2 })
    );

    setItemcount2(next2);
  };

  const renderTable = (currentgroup, it1, it2) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "100rem",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
        render: (text, record, index) => {
          return <div className="smoltxt">{text}</div>;
        },
      },
      {
        title: "count",

        render: (text, record, index) => {
          var def1 = null;
          if (itemcount?.[record.id]) {
            def1 = itemcount[record.id];
          }
          var def2 = null;
          if (itemcount2?.[record.id]) {
            def2 = itemcount2[record.id];
          }

          return (
            <div className="vertical-flex">
              <Input
                type={"number"}
                placeholder=" "
                defaultValue={def1}
                className={"inputwidth"}
                min={0}
                width={"100%"}
                step={1}
                onChange={(e) => {
                  changequantity(record.id, e.target.value);
                }}
                addonAfter={<span className="tinytxt">{record.unit} </span>}
              />

              {record.second_unit_rate &&
              record.second_unit &&
              parseFloat(record.second_unit_rate) > 0 &&
              parseFloat(record.second_unit_rate) !== 1 ? (
                <Input
                  type={"number"}
                  placeholder=" "
                  className={"inputwidth"}
                  min={0}
                  width={"100%"}
                  defaultValue={def2}
                  step={1}
                  onChange={(e) => {
                    changequantity2(
                      record.id,
                      e.target.value,
                      record.second_unit_rate
                    );
                  }}
                  addonAfter={
                    <span className="tinytxt">{record.second_unit} </span>
                  }
                />
              ) : null}
            </div>
          );
        },
      },
    ];

    return (
      <Collapse defaultActiveKey={["1"]} className={"category_containter"}>
        <Panel header={currentgroup.category} key="1">
          <Table
            columns={columns}
            dataSource={currentgroup.products}
            pagination={false}
            showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  const summarizeAudit = (thisitemcount, thisitemcount2) => {
    var audited_items = [];

    branchitems.inventory.forEach((item) => {
      var itemID = item.id;
      var itemsum = 0;
      var exist = false;

      if (thisitemcount?.[itemID] || thisitemcount?.[itemID] == 0) {
        itemsum = itemsum + thisitemcount[itemID];
        exist = true;
      }
      if (thisitemcount2?.[itemID] || thisitemcount2?.[itemID] == 0) {
        itemsum =
          itemsum +
          parseFloat(thisitemcount2[itemID]) *
            parseFloat(item.second_unit_rate);
        exist = true;
      }

      if (exist) {
        var userLocation = user.branch;
        var varname = `${userLocation}_count`;
        var varname2 = `${userLocation}_restock`;

        var new_item = {
          id: item.id,
          name: item.name,
          category: item.category,
          category_name: item.category_name,
          unit: item.unit,
          second_unit: item.second_unit,
          second_unit_rate: item.second_unit_rate,
          cost_peso: item.cost_peso,
          cost_rmb: item.cost_rmb,
          old_restock: item[varname2],
          old_count: item[varname],
          new_count: itemsum,
          main_unit_input: thisitemcount[itemID],
          second_unit_input: thisitemcount2[itemID],
          regionalization: item.regionalization,
        };

        Object.keys(new_item).forEach(
          (key) => new_item[key] === undefined && delete new_item[key]
        );
        audited_items.push(new_item);
      } else {
        message.error(`${item.name} not yet audited`);
      }
    });

    var audited_items_premix = [];
    var premix_items = [];
    branchitems.premix.map((item) => {
      var itemID = item.id;
      var itemsum = 0;
      var exist = false;

      if (thisitemcount?.[itemID] || thisitemcount?.[itemID] == 0) {
        itemsum = itemsum + thisitemcount[itemID];
        exist = true;
      }
      if (thisitemcount2?.[itemID] || thisitemcount2?.[itemID] == 0) {
        itemsum =
          itemsum +
          parseFloat(thisitemcount2[itemID]) *
            parseFloat(item.second_unit_rate);
        exist = true;
      }

      if (exist) {
        var userLocation = user.branch;
        var varname = `${userLocation}_count`;
        var varname2 = `${userLocation}_restock`;

        var new_item = {
          id: item.id,
          name: item.name,
          category: item.category,
          category_name: item.category_name,
          unit: item.unit,
          second_unit: item.second_unit,
          second_unit_rate: item.second_unit_rate,
          cost_peso: item.cost_peso,
          cost_rmb: item.cost_rmb,
          old_restock: item[varname2],
          old_count: item[varname],
          new_count: itemsum,
          main_unit_input: thisitemcount[itemID],
          second_unit_input: thisitemcount2[itemID],
          regionalization: item.regionalization,
        };

        if (item.ingredients) {
          var new_ingredients = [];
          item.ingredients.map((ingrdnt) => {
            var quantity_to_add =
              parseFloat(itemsum) * parseFloat(ingrdnt.quantity);
            var new_ingrdnt = {
              ...ingrdnt,
              quantity_to_add: quantity_to_add,
            };
            new_ingredients.push(new_ingrdnt);
            premix_items.push(new_ingrdnt);
          });

          new_item["ingredients"] = new_ingredients;
        }

        Object.keys(new_item).forEach(
          (key) => new_item[key] === undefined && delete new_item[key]
        );

        audited_items_premix.push(new_item);
      } else {
        message.error(`${item.name} not yet audited`);
      }
    });

    if (audited_items.length > 0 || audited_items_premix.length > 0) {
      createAudit(audited_items, audited_items_premix, premix_items);
    } else {
      message.warning("input quatity for an item");
    }

    // allow audit items any point of the day

    // if(audited_items.length == branchitems.inventory.length && audited_items_premix.length == branchitems.premix.length){
    //   createAudit(audited_items,audited_items_premix,premix_items)

    //   // console.log(audited_items)
    // }else{
    //    message.warning('input quatity for an item')
    // }
  };

  const createAudit = async (
    audited_items,
    audited_items_premix,
    premix_items
  ) => {
    if (!loading) {
      setLoading(true);
      message.info("recording audit");

      await Promise.all(
        audited_items.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventory(
              indx.id,
              indx.name,
              indx.new_count,
              "change",
              "audited"
            )
          );
          message.info(
            `(${i + 1}/${audited_items.length + premix_items.length})  ${
              indx.name
            } updated`
          );
        })
      );

      await Promise.all(
        premix_items.map(async (indx, i) => {
          var product4 = await dispatch(
            setProductInventory(
              indx.product,
              indx.product_name,
              indx.quantity_to_add,
              "add",
              "added from premix audit"
            )
          );
          message.info(
            `(${i + 1 + audited_items.length}/${
              audited_items.length + premix_items.length
            })  ${indx.name} (premix) updated`
          );
        })
      );

      var newsold = await dispatch(
        setMonthlyInventory(
          [...audited_items, ...audited_items_premix],
          createDate,
          currentWeighted
        )
      );
      localStorage.removeItem(STORAGE_KEY);
      setLoading(false);
      closeModal("reset");
    }
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          {/* <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e)=>{setCreatedDate(e)}}
          /> */}
        </div>
        <div>
          <Popconfirm
            title="Are you sure this list is correct?"
            onConfirm={() => {
              summarizeAudit(itemcount, itemcount2);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              Submit Inventory
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      if (action == "reset") {
        localStorage.removeItem(STORAGE_KEY);
        setItemcount([]);
        setItemcount2([]);
      }

      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Add Inventory Audit`}</Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={`Add Item Count`}
          visible={isModalVisible}
          className={"minwidthis50 nopadding"}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
          bodyStyle={{ padding: "0px" }}
        >
          <div className="audit-content">
            {categorized.map((cat) => {
              return renderTable(cat, itemcount, itemcount2);
            })}

            <Divider orientation="left">PREMIX</Divider>

            {categorized_premix.map((cat) => {
              return renderTable(cat, itemcount, itemcount2);
            })}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
